import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dental_consent = (params: StepConfigParams) => {
  return {
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'verifyPaymentNeeded',
        inputs: [],
        outputs: [],
      },
    },
    // content handled in app
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: 'helperValues.hasPaymentData',
      valueToStepName: {
        false: 'StepPaymentMethod',
        true: 'dental_purchase',
      },
    },
  } as const satisfies AnyStepConfiguration
}

export default dental_consent
